import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

import { ToastProvider, useToast } from "../common/RemitAssureToast";
import clsx from "clsx";
import * as Yup from "yup";
import { resendOtp, resetEmail, getCurrencies, sendOtpMethod } from "../../utils/Api";

import { useFormik } from "formik";

const ForgotPassword = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("+61");
  const navigate = useNavigate("");
const {showToast}=useToast();
  // New states for OTP popup
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [selectedOtpOption, setSelectedOtpOption] = useState("mobile");
  const [resetData, setResetData] = useState({});

  const initialValues = { mobile: "" };

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await getCurrencies();
        if (response?.code === "200" && response?.data?.payin_currencies) {
          const filteredCountries = response.data.payin_currencies.map(
            (item) => ({
              phone_code: item.phone_code,
              country_code: item.country_code,
            })
          );
          setCountries(filteredCountries);
          // Set default country code to first available country
          if (filteredCountries.length > 0) {
            setCountryCode(`+${filteredCountries[0].phone_code}`);
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        setCountries([]);
      }
    };

    fetchCurrencies();
  }, []);

  const forgetSchema = Yup.object().shape({
    mobile: Yup.string().min(8).max(15).required("Mobile number is required"),
  });

  let sessionID;
  setTimeout(function () {
    sessionID = sessionStorage.getItem("SessionID");
  }, 3000);

  useEffect(() => {
    if (
      sessionStorage.getItem("token") &&
      sessionStorage.getItem("remi-user-dt")
    ) {
      navigate("/dashboard");
    }
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: forgetSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const mobileNumber = parseInt(values.mobile, 10);
      const fullMobile = countryCode + mobileNumber;

      let otpPayload = {
        method: "mobile", 
        mobile: fullMobile,
        mail_subject: "Forgot Password",
        page: "forgot-password"

      };
      
      sendOtpMethod(otpPayload)
        .then((otpResponse) => {
          setLoading(false);
          if (otpResponse.code === "200" || otpResponse.code === 200) {
            // Store the mobile number for later use and show OTP popup
            setResetData({ mobile: fullMobile });
            setShowOtpPopup(true);
          } else {
            showToast('error','Error',otpResponse.message || "Failed to send OTP");
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Send OTP Error:", error);
          showToast('error','Error',error.message || "Error sending OTP. Please try again.");
        });
    },
  });

  const handleOtpPopupContinue = () => {
    setShowOtpPopup(false);
    setLoading(true);

    resetEmail({ mobile: resetData.mobile ,otp_type:selectedOtpOption})
      .then((res) => {
        setLoading(false);
        if (res?.data.code == "200") {
          // Store token and navigate to reset password
          sessionStorage.setItem("token_forgot", res?.data.token);
          
          showToast('success','Success',res?.data.message);
          
          navigate('/reset-password', { 
            state: { customer_id: res?.data.data.customer_id } 
          });
        } else if (res?.data.code === "400") {
          showToast('error','Error',res?.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        showToast('error','Error',"Something went wrong. Please try again.");
      });
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    if (/^\d*$/.test(value)) {
      formik.setFieldValue("mobile", value);
      formik.setFieldTouched("mobile", true);
    }
  };

  return (
    <>
      <section className="sigupsec" style={{ minHeight: "100vh" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="sign-image-sec">
                <img
                  src="assets/img/home/signup-left.webp"
                  className="signup"
                  alt="alt_image"
                />
              </div>
            </div>
            <div className="col-lg-7 d-flex align-items-center">
              <div className="card-body forgot-pass">
                <h2 className="Sign-heading mb-5">Forgot password?</h2>
                <form onSubmit={formik.handleSubmit} noValidate>
                  <Form.Group
                    className="mb-3 form_label"
                    controlId="formBasicMobile"
                  >
                    <Form.Label>
                      Your Mobile Number<span style={{ color: "red" }}>*</span>
                    </Form.Label>

                    <div
                      className={clsx("email-phone", {
                        invalid: formik.touched.mobile && formik.errors.mobile,
                      })}
                    >
                      <div className="row">
                        <div className="col-md-3 paddingg-l">
                          <Form.Select
                            className="login-code-select form-select"
                            value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}
                          >
                            {countries.map((country, index) => (
                              <option
                                key={index}
                                value={`+${country.phone_code}`}
                              >
                                {`+${
                                  country.phone_code
                                } (${country.country_code?.toUpperCase()})`}
                              </option>
                            ))}
                          </Form.Select>
                        </div>
                        <div className="col-md-9 mobiletext">
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="mobile"
                            size="lg"
                            value={formik.values.mobile}
                            onChange={handleMobileChange}
                            onBlur={() =>
                              formik.setFieldTouched("mobile", true)
                            }
                            className={clsx("form-control email-mobile-input", {
                              "is-invalid":
                                formik.touched.mobile && formik.errors.mobile,
                            })}
                            placeholder="Mobile Number"
                          />
                        </div>
                      </div>
                    </div>
                    {formik.touched.mobile && formik.errors.mobile && (
                      <div className="fv-plugins-message-container mt-1">
                        <div className="fv-help-block">
                          <span role="alert" className="text-danger">
                            {formik.errors.mobile}
                          </span>
                        </div>
                      </div>
                    )}
                  </Form.Group>
                  <button
                    variant="primary"
                    type="submit"
                    className="login_button"
                    disabled={loading}
                  >
                    Reset <img src="assets/img/home/Union.png"></img>
                    {loading ? (
                      <>
                        <div className="loader-overly">
                          <div className="loader"></div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </button>
                </form>
                <div className="backlogin">
                  Back to Login <a href="/login">Go Back</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OTP Selection Popup */}
      <Modal
        show={showOtpPopup}
        onHide={() => setShowOtpPopup(false)}
        centered
        dialogClassName="otp-modal"
      >
        <Modal.Body className="text-center otp-popup">
          <h4 className="fw-bold"> OTP Delivery Preference </h4>
          <p className="text-muted">
           Select where you would like to receive your One-Time Password (OTP).
          </p>
          <div className="d-flex justify-content-center gap-3 my-4">
            {/* Mobile Option */}
            <div
              className={`otp-option ${
                selectedOtpOption === "mobile" ? "active" : ""
              }`}
              onClick={() => setSelectedOtpOption("mobile")}
            >
              <FaPhoneAlt size={24} />
              <Form.Check
                label="Mobile Number"
                type="radio"
                name="otpOption"
                checked={selectedOtpOption === "mobile"}
                onChange={() => setSelectedOtpOption("mobile")}
              />
            </div>
            {/* Email Option */}
            <div
              className={`otp-option ${
                selectedOtpOption === "email" ? "active" : ""
              }`}
              onClick={() => setSelectedOtpOption("email")}
            >
              <FaEnvelope size={24} />
              <Form.Check
                type="radio"
                name="otpOption"
                checked={selectedOtpOption === "email"}
                onChange={() => setSelectedOtpOption("email")}
                label="Email Id"
              />
            </div>
          </div>
          <div className="d-flex justify-content-center mt-5">
            <Button
              className="otp-btn w-50 d-flex align-items-center justify-content-center gap-4"
              onClick={handleOtpPopupContinue}
              disabled={loading}
            >
              {loading ? "PROCESSING..." : "CONTINUE"}
              {!loading && (
                <img
                  src="https://remitassure.com/assets/img/home/Union.svg"
                  alt="arrow"
                  style={{ width: "20px", height: "20px" }}
                />
              )}
              {loading && (
                <div className="loader-overly">
                  <div className="loader"></div>
                </div>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ForgotPassword;